import { Decoder, object, field, number, string, nullable } from 'json-bouncer'

export interface TranslatedProductAttribute {
    readonly id: number|null
    readonly productId: number
    readonly key: string
    readonly value: string
}

export function translatedProductAttributeDecoder(): Decoder<TranslatedProductAttribute> {
    return object({
        id: field('id', nullable(number())),
        productId: field('productId', number()),
        key: field('key', string()),
        value: field('value', string()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/TranslatedProductAttribute.ts